import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const CurveGaussianIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick, strokeWidth = 2 }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 20 14"
    >
      <path
        d="M2 12 C4 12 6 11 7 9 C8 6 9 4 10 4 C11 4 12 6 13 9 C14 11 16 12 18 12"
        stroke={color}
        strokeWidth={strokeWidth}
        fill="none"
        strokeLinecap="round"
      />
    </BaseIcon>
  ),
);

CurveGaussianIcon.displayName = 'CurveGaussianIcon';
